// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Modal for creating a new relation (onConnect)
// ═══════════════════════════════════════════════════════════════

import { useState } from 'react';
import { useI18n } from '../../../../i18n';

interface RelationModalProps {
  sourceName: string;
  targetName: string;
  onConfirm: (tipoRelacion: string, esPrincipal: boolean) => void;
  onCancel: () => void;
}

export function RelationModal({ sourceName, targetName, onConfirm, onCancel }: RelationModalProps) {
  const [tipo, setTipo] = useState('SOLIDA');
  const [esPrincipal, setEsPrincipal] = useState(true);
  const { t } = useI18n();

  const TIPO_RELACION_OPTIONS = [
    { value: 'SOLIDA', label: t.structure.solidRelation },
    { value: 'PUNTEADA', label: t.structure.dottedRelation },
    { value: 'FUNCIONAL', label: t.structure.functionalRelation },
    { value: 'PROYECTO', label: t.structure.projectRelation },
  ];

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.4)',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '24px 28px',
          width: 400,
          maxWidth: '90vw',
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        }}
      >
        <h3
          style={{
            margin: '0 0 4px',
            fontSize: 16,
            fontWeight: 700,
            color: 'var(--color-primario)',
          }}
        >
          {t.structure.newRelation}
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: 12, color: '#6B7280' }}>
          {sourceName} → {targetName}
        </p>

        {/* Tipo relacion */}
        <label style={labelStyle}>{t.structure.relationType}</label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
          {TIPO_RELACION_OPTIONS.map((opt) => (
            <label
              key={opt.value}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 12px',
                borderRadius: 6,
                cursor: 'pointer',
                border: tipo === opt.value ? '2px solid var(--color-acento)' : '1px solid #E2E6ED',
                background: tipo === opt.value ? '#F0F9FF' : '#fff',
                fontSize: 12,
                transition: 'all 0.15s',
              }}
            >
              <input
                type="radio"
                name="tipoRelacion"
                value={opt.value}
                checked={tipo === opt.value}
                onChange={() => setTipo(opt.value)}
                style={{ accentColor: 'var(--color-acento)' }}
              />
              {opt.label}
            </label>
          ))}
        </div>

        {/* Es principal */}
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 20,
            cursor: 'pointer',
            fontSize: 12,
          }}
        >
          <input
            type="checkbox"
            checked={esPrincipal}
            onChange={(e) => setEsPrincipal(e.target.checked)}
            style={{ accentColor: 'var(--color-acento)' }}
          />
          {t.structure.isPrimaryRelation}
        </label>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={cancelBtnStyle}>
            {t.common.cancelar}
          </button>
          <button onClick={() => onConfirm(tipo, esPrincipal)} style={confirmBtnStyle}>
            {t.structure.createRelationBtn}
          </button>
        </div>
      </div>
    </div>
  );
}

const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 11,
  fontWeight: 600,
  color: '#5A6171',
  marginBottom: 6,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
};

const cancelBtnStyle: React.CSSProperties = {
  padding: '8px 16px',
  borderRadius: 6,
  border: '1px solid #D1D5DB',
  background: '#fff',
  cursor: 'pointer',
  fontSize: 12,
  fontFamily: 'inherit',
  color: '#5A6171',
};

const confirmBtnStyle: React.CSSProperties = {
  padding: '8px 16px',
  borderRadius: 6,
  border: 'none',
  background: 'var(--color-acento)',
  color: '#fff',
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 600,
  fontFamily: 'inherit',
};
